import { render, staticRenderFns } from "./go-Getails.vue?vue&type=template&id=38aa81da&scoped=true&"
import script from "./go-Getails.vue?vue&type=script&lang=js&"
export * from "./go-Getails.vue?vue&type=script&lang=js&"
import style0 from "./go-Getails.vue?vue&type=style&index=0&id=38aa81da&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38aa81da",
  null
  
)

export default component.exports